module.exports = __webpack_public_path__ + "media/images/game_icon/en/VGF02-47913b43f0a6cee7752d00bfe23aa6e1.png";